<template>
    <b-form-group>
        <label class="mb-1 text-lg d-flex align-items-center">
            Trường đại học
        </label>
        <b-input v-model="entry.university" type="text" placeholder="Nhập trường đại học..." />
    </b-form-group>
</template>

<script>
export default {
    props: {
        value: Object,
    },
    data: () => ({
        entry: {
            university: "",
        },
    }),
    watch: {
        "entry.university": {
            handler: function () {
                this.$emit("update", {
                    ...this.value,
                    university: this.entry.university,
                });
            },
            deep: true,
        },
        "value.university": {
            handler: function () {
                this.entry.university = this.value.university;
            },
            deep: true,
        },
    },
    created() {
        this.entry = this.value;
    },
};
</script>